import { config } from '../config/environment';
import { Platform } from '../types';

const TELEMETRY_URL = config.emotifyApi.url;

interface TelemetryEvent {
  eventType: 'playlist_analyzed' | 'recommendation_clicked' | 'heatmap_shared' | 'page_viewed';
  platform?: Platform;
  trackCount?: number;
  playlistId?: string;
  trackId?: string;
  method?: 'share' | 'download' | 'cover';
}

export function sendTelemetryEvent(event: TelemetryEvent): void {
  fetch(`${TELEMETRY_URL}telemetry`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(event),
  }).catch(() => {}); // fire-and-forget
}

export async function fetchTelemetryStats(): Promise<{ totalPlaylistsAnalyzed: number } | null> {
  try {
    const resp = await fetch(`${TELEMETRY_URL}telemetry/stats`);
    if (!resp.ok) return null;
    return await resp.json();
  } catch {
    return null;
  }
}
